<template>
  <section>
    <div class="left">
      <h2 v-translate>Zobrazení na zařízeních</h2>
    </div>

    <div class="right">

      <div class="field_left">
        <checkbox-input
            :disabled="disabled"
            id="firstscreen"
            value="firstscreen"
            v-model="entity.device_group_settings.firstscreen"
            @input="onChange"
        >
          <translate class="translate">First screen</translate>
        </checkbox-input>
      </div>

      <div class="field_right">
        <checkbox-input
            :disabled="disabled"
            id="secondscreen"
            value="fsecondscreen"
            v-model="entity.device_group_settings.secondscreen"
            @input="onChange"
        >
          <translate class="translate">Second screen</translate>
        </checkbox-input>
      </div>
    </div>
  </section>
</template>

<script>
import advertisingBanners from "./../mixins/advertisingBanners";

export default {
  name: "AdvertisingBannerDeviceGroupForm",
  components: {},
  mixins: [advertisingBanners],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  created() {
  },
  computed: {
    disabled(){
      return !this.isEditable;
    }
  },
  methods: {
    onChange(){
      this.$emit('input');
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Forms/DeviceGroupType.vue